<div class="container" fxLayout="column" fxLayoutAlign="flex-start stretch">
  <div class="logo-padding" fxFlex="0 0 0px" fxLayout="column" fxLayoutAlign="flex-start stretch">
    <logo logoTheme="navy" [route]="'private/overview'"></logo>
    <div class="logo-tagline">ADMIN</div>
  </div>

  <div fxLayout="column" fxFlex="1 1" fxLayoutAlign="flex-start stretch">
    <ng-container *ngIf="!isMobile; else mobileMenu">
      <suvo-bi-list-navigation
        class="links-sidenav"
        [links]="majorLinks"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
      >
      </suvo-bi-list-navigation>

      <mat-divider class="links-divider"></mat-divider>

      <div class="links-section-label">Content</div>
      <div class="links-subsection-label">Content</div>
      <suvo-bi-list-navigation
        class="links-sidenav"
        [links]="catalogContentLinks"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        [ngClass]="{ disabled: !hasRoles('ADMIN') }"
      >
      </suvo-bi-list-navigation>
      <a
        mat-list-item
        class="links-sidenav content-media-library-link"
        routerLink="/private/data-sources/media-library"
        [ngClass]="{ disabled: !hasRoles('ADMIN') }"
      >
        <span class="d-flex fd-row ai-center">
          <mat-icon>photo_library</mat-icon>
          Media Library
        </span>
      </a>

      <mat-divider class="links-subdivider"></mat-divider>

      <div class="heading-subsection heading-subsection--nav">Data sources</div>
      <suvo-bi-list-navigation
        *ngIf="dataLinks$ | async"
        class="links-sidenav"
        [links]="dataLinks$ | async"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        [ngClass]="{ disabled: !hasRoles('ADMIN') }"
      >
      </suvo-bi-list-navigation>

      <mat-divider class="links-divider"></mat-divider>

      <suvo-bi-list-navigation
        *ngIf="editingLinks"
        class="links-sidenav"
        [links]="editingLinks"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        [ngClass]="{ disabled: !hasRoles('ADMIN') }"
      >
      </suvo-bi-list-navigation>

      <mat-divider class="links-divider"></mat-divider>

      <suvo-bi-list-navigation
        class="links-sidenav"
        [links]="adminLinks"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
      >
      </suvo-bi-list-navigation>

      <mat-divider class="links-divider"></mat-divider>

      <suvo-bi-list-navigation
        class="links-sidenav"
        [links]="settingsLinks"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        [ngClass]="{ disabled: !hasRoles('ADMIN') }"
      >
      </suvo-bi-list-navigation>
    </ng-container>

    <ng-template #mobileMenu>
      <details class="mobile-section" open>
        <summary>Main</summary>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="majorLinks"
          showIcons="true"
          [borderRadius]="'12px'"
        >
        </suvo-bi-list-navigation>
      </details>

      <details class="mobile-section" *ngIf="dataLinks$ | async">
        <summary>Content</summary>
        <div class="heading-subsection heading-subsection--mobile">Content</div>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="catalogContentLinks"
          showIcons="true"
          [borderRadius]="'12px'"
          [ngClass]="{ disabled: !hasRoles('ADMIN') }"
        >
        </suvo-bi-list-navigation>
        <a
          mat-list-item
          class="links-sidenav mobile-links content-media-library-link"
          routerLink="/private/data-sources/media-library"
          [ngClass]="{ disabled: !hasRoles('ADMIN') }"
        >
          <span class="d-flex fd-row ai-center">
            <mat-icon>photo_library</mat-icon>
            Media Library
          </span>
        </a>

        <div class="mobile-subdivider"></div>

        <div class="heading-subsection heading-subsection--mobile">Data sources</div>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="dataLinks$ | async"
          showIcons="true"
          [borderRadius]="'12px'"
          [ngClass]="{ disabled: !hasRoles('ADMIN') }"
        >
        </suvo-bi-list-navigation>
      </details>

      <details class="mobile-section" *ngIf="editingLinks">
        <summary>Editing</summary>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="editingLinks"
          showIcons="true"
          [borderRadius]="'12px'"
          [ngClass]="{ disabled: !hasRoles('ADMIN') }"
        >
        </suvo-bi-list-navigation>
      </details>

      <details class="mobile-section">
        <summary>Admin</summary>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="adminLinks"
          showIcons="true"
          [borderRadius]="'12px'"
        >
        </suvo-bi-list-navigation>
      </details>

      <details class="mobile-section">
        <summary>Settings</summary>
        <suvo-bi-list-navigation
          class="links-sidenav mobile-links"
          [links]="settingsLinks"
          showIcons="true"
          [borderRadius]="'12px'"
          [ngClass]="{ disabled: !hasRoles('ADMIN') }"
        >
        </suvo-bi-list-navigation>
      </details>
    </ng-template>
  </div>

  <mat-nav-list fxFlex="0 0 256px" fxFlex.xs="0 0 25vh" class="account-sidenav">
    <suvo-bi-account-sidenav-widget
      [logoutRoute]="['/', 'login']"
      [loadOrganisation]="false"
      [tenantSelectorLink]="['/', 'shops']"
      (onLogout)="handleLogout()"
    ></suvo-bi-account-sidenav-widget>
  </mat-nav-list>
</div>
